import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import routes from "../../routes";
import { applicationOverviewRoutesMap, CONVENTIONAL, ISLAMIC } from "../../constants";
import { getAccountType, getIsIslamicBanking } from "../../store/selectors/appConfig";
import { useTrackingHistory } from "../../utils/useTrackingHistory";
import { StyledHeaderBtnGroup } from "./styled";
import { TrackNSwitchAccountBtn } from "../../commonStyles";

export const HeaderButtonGroup = ({
  classes,
  detailedAccountRoutesMap,
  showSwitchButton = true,
  buttonColor = "black"
}) => {
  const accountType = useSelector(getAccountType);
  const pushHistory = useTrackingHistory();
  const queryParams = useLocation().search;
  const isIslamic = useSelector(getIsIslamicBanking);

  const handleRedirection = (path, replaceHistory = false) => {
    pushHistory(path, replaceHistory);
  };
  const route = detailedAccountRoutesMap || applicationOverviewRoutesMap;

  return (
    <StyledHeaderBtnGroup className={classes}>
      <TrackNSwitchAccountBtn
        buttonColor={buttonColor}
        variant="outlined"
        onClick={() => handleRedirection(routes.comeBackLogin)}
      >
        Resume
      </TrackNSwitchAccountBtn>
      {showSwitchButton && (
        <TrackNSwitchAccountBtn
          buttonColor={buttonColor}
          variant="outlined"
          className="switchAccountBtn"
          onClick={() =>
            handleRedirection(
              isIslamic
                ? route[accountType][CONVENTIONAL] + queryParams
                : route[accountType][ISLAMIC] + queryParams,
              true
            )
          }
        >
          {isIslamic ? "Switch to Conventional" : "Switch to RAKislamic"}
        </TrackNSwitchAccountBtn>
      )}
    </StyledHeaderBtnGroup>
  );
};
